/*数据处理*/
var dataTypeList = [
	'date_time_BCD5',
	'date_time_BCD6',
	'signedBCD',
	'unsigned BCD',
	'NULL',
	'array',
	'structure',
	'bool',
	'bit - string',
	'double-long',
	'double-long-unsigned',
	'octet - string',
	'visible-string',
	'integer',
	'long',
	'unsigned',
	'long - unsigned',
	'long64',
	'long64 - unsigned',
	'enum',
	'float32',
	'float64',
	'date_time_s',
	'double-long_swap',
	'double-long-unsigned_swap',
	'long64_swap',
	'long64-unsigned_swap',
	'float32_swap',
	'float64_swap',
]
export default {
	dataTypeList
}


//////////////////
// WEBPACK FOOTER
// ./static/js/dataList.js
// module id = nxEW
// module chunks = 0